// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","443":"about","631":"contact","637":"order","729":"term"}[chunkId] + "." + {"296":"70db4d35","443":"0c96b925","631":"84b43a3f","637":"7f109a27","729":"0cdcd41b"}[chunkId] + ".js";
};